import { Component } from '@angular/core';

@Component({
  selector: 'app-newsletters',
  standalone: true,
  imports: [],
  templateUrl: './newsletters.component.html',
  styleUrl: './newsletters.component.scss'
})
export class NewslettersComponent {

}
